import Groups from './Groups.yaml?component';
import GeneralSettings from './GeneralSettings.yaml?component';
import InvoicingProviderSettings from './InvoicingProviderSettings.yaml?component';
import JobSchedulerConfig from './JobSchedulerConfig.yaml?component';
import JobSchedulerConfigurations from './JobSchedulerConfigurations.yaml?component';
import MailAccountConfig from './MailAccountConfig.yaml?component';
import MailAccountConfigurations from './MailAccountConfigurations.yaml?component';
import ExpenseTypes from './ExpenseTypes.yaml?component';
import NAVOnlineInvoiceInterfacePanel from './NAVOnlineInvoiceInterfacePanel.yaml?component';
import NAVOnlineInvoiceInterfaceSettings from './NAVOnlineInvoiceInterfaceSettings.yaml?component';
import PrinterConfig from './Printers.yaml?component';
import Printers from './PrinterConfig.yaml?component';
import PrinterTester from './PrinterTester.yaml?component';
import Settings from './Settings.yaml?component';
import SettingsInvoicing from './SettingsInvoicing.yaml?component';
import StatData from './StatData.yaml?component';
import TagsEditor from './TagsEditor.yaml?component';
import Tasks from './Tasks.yaml?component';
import UcMailAccountSelector from './UcMailAccountSelector.yaml?component';
import UcPrinterSelector from './UcPrinterSelector.yaml?component';
import UnitsEditor from './UnitsEditor.yaml?component';
import VATPeriods from './VATPeriods.yaml?component';

export {
	TagsEditor,
	GeneralSettings,
	Groups,
	InvoicingProviderSettings,
	JobSchedulerConfig,
	JobSchedulerConfigurations,
	MailAccountConfig,
	MailAccountConfigurations,
	ExpenseTypes,
	NAVOnlineInvoiceInterfacePanel,
	NAVOnlineInvoiceInterfaceSettings,
	PrinterConfig,
	Printers,
	PrinterTester,
	Settings,
	SettingsInvoicing,
	StatData,
	Tasks,
	UcMailAccountSelector,
	UcPrinterSelector,
	UnitsEditor,
	VATPeriods
};
